import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HeaderService } from "../service/header.service";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
import { UserTrackingService } from "../../../../@core/utils";

@Component({
  selector: "ltts-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  user: any;
  isPersonalInfoAccordionOpen: boolean = true;
  isContactInfoAccordionOpen: boolean = false;
  isEmpInfoAccordionOpen: boolean = false;
  private cmsbase_url = environment.CMSURL_IMG

  @Output() closeMenuEvent = new EventEmitter<boolean>();
  @Input() set profileData(val) {
    if (val) {
      this.user = val;
      const parts = this.user.dateOfJoining.split("-");
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
      //this.user.dateOfJoining = new Date(day, month, year);
      this.user.employeeName = this.removeSpecialCharacters(
        this.user?.employeeName
      );
      this.user.picture =
        this.cmsbase_url+"wp-content/uploads/2025/05/nick.png";
    }
  }

  removeSpecialCharacters(input: string): string {
    return input.replace(/[^a-zA-Z0-9 ]/g, " ");
  }

  constructor(private headerService: HeaderService, private router: Router,
    private userTrackService: UserTrackingService
  ) {}
  ngOnInit(): void {
    const me = this;
  }
  onCloseMenu(event?: Event) {
    const me = this;
    me.closeMenuEvent.next(true);
    event?.preventDefault();
    this.userTrackService.track('ProfileMenuClosed', {'value':'CloseMenu'}, 'Menu Closed');
  }
  navigateById(id, event?: Event) {
    event?.preventDefault();
    this.closeMenuEvent.next(true);
    this.router.navigateByUrl("my-team/" + btoa(id));
    this.userTrackService.track('NavigeteToMyTeam', {'value':'MyTeamInnerPage'}, 'RedirectionMyTeam');
  }
  getProfileImageSrc(image: string): string {
    if (image && image.startsWith("data:image/png;base64,")) {
      return image;
    }
    if (image && !image.startsWith("data:image/png;base64,")) {
      return "data:image/png;base64," + image;
    }
    return this.cmsbase_url+"wp-content/uploads/2025/05/dumy.jpg";
  }

  /**
   * Method to toggle the state of an accordion
   * @param accordionKey - The key representing the accordion state (e.g., 'isPersonalInfoAccordionOpen')
   * @author Rishabh Kumar
   */
  toggleAccordionState(accordionKey: string): void {
    const me = this;
    me[accordionKey] = !me[accordionKey];
  }
}
